"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScoreKeyLike = exports.ScoreKeyToReadingKey = exports.ReadingKeyToScoreKey = void 0;
/** Calculates the score key from a reading key, by prefixing it with `score_` */
const ReadingKeyToScoreKey = (k) => `score_${k}`;
exports.ReadingKeyToScoreKey = ReadingKeyToScoreKey;
/** Calculates the reading key from a score key, by removing the `score_` prefix */
const ScoreKeyToReadingKey = (k) => {
    if ((0, exports.isScoreKeyLike)(k)) {
        return k.replace('score_', '');
    }
    return k;
};
exports.ScoreKeyToReadingKey = ScoreKeyToReadingKey;
const isScoreKeyLike = (k) => k.startsWith('score_');
exports.isScoreKeyLike = isScoreKeyLike;
